import { z } from 'zod';

const selectOptionSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const uploadInvoiceSchema = z.object({
  type: z.string().min(1, 'Type is required'),
  file: z.instanceof(File, { message: 'File is required' }).nullable(),
  description: z.string().min(1, 'Invoice/Quote Number is required'),
  dealerContact: z.array(selectOptionSchema),
  lenderContact: z.array(selectOptionSchema),
});

export type UploadInvoiceFormValues = z.infer<typeof uploadInvoiceSchema>;
